import { defineComponent as _defineComponent } from 'vue'
import Titap from "@/components/widgets/input/Tiptap.vue"
import { ref, onMounted, watch } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TextEditor',
  props: {
  label: {
    type: String,
    required: false,
  },
  value: {
    type: String,
    required: true,
  },
  errorMessages: {
    type: Array,
    default: () => [],
  },
  height: {
    type: String,
    required: false,
  },
  outlined: {
    type: Boolean,
    default: true,
  },
  autofocus: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    required: false,
  },
},
  emits: ["input", "enter"],
  setup(__props, { expose, emit }) {

const { label, value } = __props



const editorContent = ref("")


onMounted(() => {
  editorContent.value = value
})

watch(
  () => value,
  (newValue) => {
    editorContent.value = newValue
  }
)

watch(
  () => editorContent.value,
  (value) => {
    emit("input", value)
  }
)

const clearContent = () => {
  editorContent.value = ""
}

expose({
  clearContent,
})

return { __sfc: true,editorContent, emit, clearContent, Titap }
}

})